import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/pricing/assets';

import FaqItem from '../../components/modules/FaqItem';
import Image from '../../components/modules/Image';

import faqItems from '../../configs/pages/pricing/faq.js';
import generalStyles from './style/faq.module.css';

export default function Faq() {
  return (
    <PageWrap size="l">
      <Spacing size="xl" position="topBottom" type="padding">
        <div className={generalStyles.faq}>
          <div className={generalStyles.text}>
            <div className={generalStyles.textHolder}>
              <h2 className={generalStyles.heading}>
                Frequently asked questions
              </h2>
              <div className={generalStyles.image}>
                <Image {...assets.faq} width="100px" hasShadow={false} />
              </div>
            </div>
          </div>
          <div className={generalStyles.grid}>
            {faqItems.map(item => (
              <FaqItem key={item.id} question={item.question}>
                {item.answer}
              </FaqItem>
            ))}
          </div>
        </div>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pricing/Faq.js